import { ILocationField, ISharedResponsible } from '~/client/graph'

import ProjectsStore from '../stores/domain/Projects.store'

export class SharedInfo {
  public constructor(
    public responsible: ISharedResponsible,
    public companyName: string,
    public projectUrl: string,
    public locationsTo: ILocationField[],
    public locationsFrom: ILocationField[],
    public locationName: string,
    public locationUrl: string,
    public projectFromId?: string,
  ) {}
}

export function getSharedProjectName(
  projectUrl: string,
  projectsStore?: ProjectsStore,
  projectId?: string,
): string {
  if (projectsStore && projectId) {
    const project = projectsStore.getProjectById(projectId)
    if (project) {
      return project.name
    }
  }
  const url = new URL(projectUrl)
  return url.pathname.split('/').pop()
}
